import ReportSalesOrder from "../../../../components/@reports/sales/ReportSalesOrder";

import { ReportContextProvider } from "../../../../context/ReportContext";

import { reportScopes, reportTypes } from "../../../../hooks/api/useReports";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

import { validationSchema, initialValues, advancedValidationSchema, advancedInitialValues } from "../../../../schema/reports/sales/salesOrderSchema"

export default function SalesOrderReport() {

    let routeType = routeTypes.admin

    return (
        <ReportContextProvider
            routeType={routeType}
            reportScope={reportScopes.sales}
            reportType={reportTypes.sales.salesOrder.id}
            validationSchema={validationSchema}
            advancedValidationSchema={advancedValidationSchema}
            initialValues={initialValues}
            advancedInitialValues={advancedInitialValues}
        >
            <ReportSalesOrder
                routeType={routeType}
            />
        </ReportContextProvider>
    )
}       